import React from "react";
import './HealthHomeProgressBar.scss';

const HealthHomeProgressBar = ({ type, value, maxValue }) =>
  <progress value={value} className={`--${type}`} max={maxValue} />

export default HealthHomeProgressBar;